import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private notificationSubject = new Subject<string>();

  constructor() { }

  shareData(data: string){
    this.notificationSubject.next(data);
  }

  getData(): Subject<any>{
    return this.notificationSubject;
  }
}
